// extracted by mini-css-extract-plugin
export default {"error":"text-error_error__4CjsA"};